import { render } from "./CustomizedVersionSelect.vue?vue&type=template&id=72051eb2&scoped=true"
import script from "./CustomizedVersionSelect.vue?vue&type=script&lang=js"
export * from "./CustomizedVersionSelect.vue?vue&type=script&lang=js"

import "./CustomizedVersionSelect.vue?vue&type=style&index=0&id=72051eb2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72051eb2"]])

export default __exports__